import { Dispatch } from 'redux';
import {
  AddOrganizationAction,
  DeleteOrganizationAction,
  GetOrgsAction,
  InvokeDeleteOrgModalAction,
  SetCurrentOrgAction,
  UpdateOrganizationAction,
  UpdateOrgValues,
} from './orgs.types';
import axios from '../../axios';
import { Organization } from '../../types';
import { AddOrgForm } from '../../pages/Organizations/components/AddOrganization/useOrgForm';

export const GET_ORGS = 'GET_ORGS';
export const ADD_ORGANIZATION = 'ADD_ORGANIZATION';
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
export const SET_CURRENT_ORG = 'SET_CURRENT_ORG';
export const INVOKE_DELETE_ORG_MODAL = 'INVOKE_DELETE_ORG_MODAL';
export const DELETE_ORGANIZATION = 'DELETE_ORGANIZATION';

export const getOrgs = () => async (
  dispatch: Dispatch<GetOrgsAction>
): Promise<void> => {
  const orgs = await axios.get('/services/orgs/');
  dispatch({
    type: GET_ORGS,
    payload: orgs.data.payload,
  });
};

export const addOrganization = (
  values: AddOrgForm,
  orgId: string,
  userId: string
) => async (dispatch: Dispatch<AddOrganizationAction>): Promise<void> => {
  try {
    const orgInvite = { ...values, inviteType: 'ownerInvite' };
    await axios.post(
      `/services/orgs/${orgId}/invites?requesterId=${userId}`,
      orgInvite
    );
    dispatch({
      type: ADD_ORGANIZATION,
      payload: values,
    });
  } catch (e) {
    // eslint-disable-next-line
    console.log(e);
  }
};

export const updateOrganization = (
  values: UpdateOrgValues,
  orgId: string,
  isCurrentOrg: boolean
) => async (dispatch: Dispatch<UpdateOrganizationAction>): Promise<void> => {
  const valuesToUpdate = {
    ...values,
    newAvatar: values.avatar
      ? { contentType: 'image/png', b64content: values.avatar.split(',')[1] }
      : null,
  };
  const updatedOrg = await axios.patch(
    `/services/orgs/${orgId}`,
    valuesToUpdate
  );
  dispatch({
    type: UPDATE_ORGANIZATION,
    payload: { org: updatedOrg.data.payload, isCurrentOrg },
  });
};

export const setCurrentOrg = (org: Organization): SetCurrentOrgAction => ({
  type: SET_CURRENT_ORG,
  payload: org,
});

export const invokeDeleteOrgModal = (): InvokeDeleteOrgModalAction => ({
  type: INVOKE_DELETE_ORG_MODAL,
});

export const deleteOrganization = (orgId: string) => async (
  dispatch: Dispatch<DeleteOrganizationAction>
): Promise<void> => {
  await axios.delete(`/services/orgs/${orgId}`);
  dispatch({
    type: DELETE_ORGANIZATION,
    payload: orgId,
  });
};
